<template>
  <div>
    <v-card class="pa-5" outlined>
      <v-card-title>
        <div class="d-flex align-center justify-start">
          <h2>Users</h2>
          <v-btn class="ml-5" @click="refreshUsers">Refresh Users <v-icon class="ml-2" small>fa-sync-alt</v-icon></v-btn>
          <v-btn class="ml-3" @click="exportCSV">Export to CSV<v-icon class="ml-2" small>fa-share</v-icon></v-btn>
        </div>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" prepend-icon="fa-search" hide-details label="Search by email or username..." single-line/>
        <v-btn class="ml-5" @click="searchUser(search)">Search</v-btn>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="users"
        hide-default-footer
        :v-bind:options.sync="pagination"
        @update:pagination="refreshUsers"
        class="elevation-1"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon class="mr-2 icon" small @click="showUser(item)">fa-eye</v-icon>
          <v-icon class="mr-2 icon" small @click="goToTrades(item)">fa-stream</v-icon>
          <v-icon class="mr-2 icon" small @click="goToAccounts(item)">fa-wallet</v-icon>
          <v-icon class="mr-2 icon" small @click="editUser(item)">fa-certificate</v-icon>
          <v-icon class="icon" small @click="sendEmail(item)">fa-envelope</v-icon>
        </template>
      </v-data-table>
      <v-pagination
        v-model="pagination.page"
        :length="this.$store.state.userPagination.totalPages"
        :total-visible="7"
        @input="refreshUsers"
        ></v-pagination>
    </v-card>

    <v-overlay :value="overlayShowUser">
      <ShowUser :user="user" @closeWindow="overlayShowUser = false"/>
    </v-overlay>
    <v-overlay :value="overlayEditUser">
      <EditUser :user="user" @closeWindow="overlayEditUser = false"/>
    </v-overlay>
    <v-overlay :value="overlaySendEmail">
      <SendEmail :user="user" @closeWindow="overlaySendEmail = false"/>
    </v-overlay>
    <v-overlay v-model="overlayUserAccounts">
      <UserAccounts :user="user" @closeWindow="overlayUserAccounts = false"/>
    </v-overlay>
  </div>
</template>

<script>
import EditUser from "../views/Users/EditUser";
import ShowUser from "../views/Users/ShowUser";
import SendEmail from "../views/Mail/SendEmail";
import UserAccounts from "@/views/Users/UserAccounts";

export default {
  name: "UsersTable",
  components: {UserAccounts, SendEmail, ShowUser, EditUser},
  props: {
    users: Array,
  },
  computed: {
    pageCount() {
      return Math.ceil(this.users.length / this.itemsPerPage);
    },
  },
  data() {
    return {
      user: null,
      overlayShowUser: false,
      overlayEditUser: false,
      overlaySendEmail: false,
      overlayUserAccounts: false,
      search: '',
      headers: [
        {text: 'User ID', align: 'start', sortable: true, value: 'user.id',},
        {text: 'First Name', align: 'start', sortable: true, value: 'user.firstName',},
        {text: 'Last Name', align: 'start', sortable: true, value: 'user.lastName',},
        {text: 'Email', align: 'start', sortable: true, value: 'user.email',},
        {text: 'Username', align: 'start', sortable: false, value: 'user.login',},
        {text: 'Country', align: 'start', sortable: true, value: 'country',},
        {text: 'Actions', align: 'start', sortable: false, value: 'actions',},
      ],

      pagination:{
        itemsPerPage: this.$store.state.userPagination.size,
        page: this.$store.state.userPagination.currentPage,
      }
    };
  },
  methods: {
    goToTrades(user) {
      this.$router.push({ name: 'trades', params: { userId: user.user.id }});
    },
    goToAccounts(user) {
      this.user = user;
      this.overlayUserAccounts = true;
    },
    showUser(user) {
      this.user = user;
      this.overlayShowUser = true;
    },
    editUser(user) {
      this.user = user;
      this.overlayEditUser = true;
    },
    sendEmail(user) {
      this.user = user;
      this.overlaySendEmail = true;
    },
    refreshUsers(page) {
      this.$store.state.userPagination.currentPage = page;
      this.$emit('refreshUsers');
    },
    searchUser(filter){
      this.$store.state.userPagination.currentPage = 0
       let email = "";
      let login = "";
      if(filter!=undefined && filter.includes("@"))
        email = filter;
      else
        login = filter;
      this.$emit("refreshUsers", email,login);
    },
    exportCSV() {
      let rows = [['ID', 'Username', 'First Name', 'Last Name', 'Email', 'Activated', 'Language', 'Converted From', 'Phone Number', 'Country', 'Arrived From', 'Type of Trader',
        'Pro Expiration Time', 'Telegram Id', 'Referred From', 'Last Login', 'Commercial State', 'Usage State'],];

      this.$store.state.users.forEach((userDetails) => {
        rows.push([
          `${userDetails.user.id}`,
          `${userDetails.user.login}`,
          `${userDetails.user.firstName}`,
          `${userDetails.user.lastName}`,
          `${userDetails.user.email}`,
          `${userDetails.user.activated}`,
          `${userDetails.user.langKey}`,
          `${userDetails.convertedFrom}`,
          `${userDetails.phoneNumber}`,
          `${(userDetails.country !== null)? userDetails.country : ''}`,
          `${userDetails.arrivedFromChannel}`,
          `${userDetails.type}`,
          `${userDetails.proExpirationDate}`,
          `${(userDetails.telegramId !== null)? userDetails.telegramId : ''}`,
          `${(userDetails.referredFrom !== null)? userDetails.referredFrom : ''}`,
          `${(userDetails.lastLogin !== null)? userDetails.lastLogin : ''}`,
          `${userDetails.commercialState}`,
          `${userDetails.usageState}`,
        ]);
      });
      let csvContent = "data:text/csv;charset=utf-8," + rows.map(e => e.join(",")).join("\n");

      // Encoding and data downloading
      let encodedUri = encodeURI(csvContent);
      let link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "Swiset Users.csv");
      document.body.appendChild(link);
      link.click();
      alert(`Successfully exported data with ${rows.length} rows on file.`);
    },
  }
}
</script>

<style scoped>

</style>
